export default class UrlUtils {
  static isValidInternalPath(path: string | null | undefined): path is string {
    if (!path) return false;
    if (!path.startsWith('/') || path.startsWith('//')) return false;
    if (path.includes(':')) return false;
    return true;
  }
}
